// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-composer-dock {
  background: #ffffff;
}

.stop-response-icon {
  color: red;
  padding: 0.375rem 0.5rem;
  border-radius: 9999px;
  border: 1px solid red;
}

.stop-response-icon:hover {
  cursor: pointer;
}

.send-container:focus {
  --tw-ring-color: none !important;
}

/* MCP specific toggle styles */
.mcpSwitch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 20px;
}

.mcpSwitch input {
  display: block;
  position: absolute;
  width: 30px;
  opacity: 0 !important;
  height: 20px;
  z-index: 10;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

.mcpSlider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  width: 30px;
  height: 20px;
  pointer-events: none;
}

.mcpSlider:before {
  position: absolute;
  content: '';
  height: 14px;
  width: 13px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  pointer-events: none;
}

input:checked + .mcpSlider {
  background-color: #0066ff;
}

input:focus + .mcpSlider {
  box-shadow: 0 0 1px #0066ff;
}

input:checked + .mcpSlider:before {
  transform: translateX(12px);
}

.mcpSlider.round {
  border-radius: 34px;
}

.mcpSlider.round:before {
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/modules/end-user/chat/pages/chat-screen/query-container/query-container.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".chat-composer-dock {\n  background: #ffffff;\n}\n\n.stop-response-icon {\n  color: red;\n  padding: 0.375rem 0.5rem;\n  border-radius: 9999px;\n  border: 1px solid red;\n}\n\n.stop-response-icon:hover {\n  cursor: pointer;\n}\n\n.send-container:focus {\n  --tw-ring-color: none !important;\n}\n\n/* MCP specific toggle styles */\n.mcpSwitch {\n  position: relative;\n  display: inline-block;\n  width: 30px;\n  height: 20px;\n}\n\n.mcpSwitch input {\n  display: block;\n  position: absolute;\n  width: 30px;\n  opacity: 0 !important;\n  height: 20px;\n  z-index: 10;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n}\n\n.mcpSlider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  width: 30px;\n  height: 20px;\n  pointer-events: none;\n}\n\n.mcpSlider:before {\n  position: absolute;\n  content: '';\n  height: 14px;\n  width: 13px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  pointer-events: none;\n}\n\ninput:checked + .mcpSlider {\n  background-color: #0066ff;\n}\n\ninput:focus + .mcpSlider {\n  box-shadow: 0 0 1px #0066ff;\n}\n\ninput:checked + .mcpSlider:before {\n  -webkit-transform: translateX(12px);\n  -ms-transform: translateX(12px);\n  transform: translateX(12px);\n}\n\n.mcpSlider.round {\n  border-radius: 34px;\n}\n\n.mcpSlider.round:before {\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
